import { render, staticRenderFns } from "./giftcardbalance.vue?vue&type=template&id=56225c9e&"
import script from "./giftcardbalance.vue?vue&type=script&lang=js&"
export * from "./giftcardbalance.vue?vue&type=script&lang=js&"
import style0 from "./giftcardbalance.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports